var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharpFastfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.577,
    height: 22.577,
    viewBox: "0 0 22.577 22.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H22.577V22.577H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.992,4.763V1H15.111V4.763h-4.7l.216,2.173c3.452.8,6.369,3.255,6.369,7.234l.019,7.526H20L21.7,4.763ZM1,19.814H15.111V21.7H1Zm7.055-11.3C4.528,8.516,1,10.407,1,14.17H15.111C15.111,10.407,11.583,8.516,8.055,8.516ZM1,16.051H15.111v1.881H1Z",
    transform: "translate(-0.059 -0.059)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpFastfood);
export default __webpack_public_path__ + "static/media/sharp-fastfood.f2aa4806d72d3d7bd3ab7850380ef6ab.svg";
export { ForwardRef as ReactComponent };